import { z } from "zod";
/** Every theme the app offers; the app's theme options must list exactly these. */
export const APP_THEME_IDS = [
    "theme-light-blue",
    "theme-light",
    "theme-editorial",
    "theme-light-violet",
    "theme-light-teal",
    "theme-light-green",
    "theme-light-rose",
    "theme-charcoal",
    "theme-charcoal-blue",
    "theme-charcoal-violet",
    "theme-charcoal-teal",
    "theme-charcoal-green",
    "theme-charcoal-rose",
    "theme-charcoal-editorial",
    "dark",
    "theme-dark-blue",
    "theme-dark-violet",
    "theme-dark-teal",
    "theme-dark-green",
    "theme-dark-rose",
    "theme-dark-editorial",
];
/** "system" follows the device between a light and a dark theme. */
export const appThemeChoiceSchema = z.enum([...APP_THEME_IDS, "system"]);
/** A signed-in person's preferences; appTheme is null until they save one. */
export const workspacePreferencesResponseSchema = z.object({
    appTheme: appThemeChoiceSchema.nullable(),
});
export const workspacePreferencesUpdateSchema = z.object({
    appTheme: appThemeChoiceSchema,
}).strict();
